import * as React from "react";
const SvgFiRrChallengeAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-challenge-alt_svg__a)">
      <path
        fill="#062147"
        d="M1.5 3.5a2.5 2.5 0 1 1 4.999 0 2.5 2.5 0 0 1-5 0M3 17v3a1 1 0 0 1-.051.316l-1 3a1.001 1.001 0 0 1-1.897-.633L1 19.837V9.999A3.003 3.003 0 0 1 3.949 7L4 6.999h4.17a1 1 0 0 0 .709-.293l1.914-1.914a.999.999 0 1 1 1.414 1.414L10.294 8.12a2.98 2.98 0 0 1-2.122.879H7v6h2c1.103 0 2 .897 2 2v2a1 1 0 1 1-2 0v-2zm0-2h2V9H4c-.551 0-1 .448-1 1zm10.67-7.366.53-.306a4.5 4.5 0 0 1 0-2.656l-.53-.306a1 1 0 0 1 1-1.732l.533.307A4.5 4.5 0 0 1 17.5 1.612V1a1 1 0 1 1 2 0v.612a4.5 4.5 0 0 1 2.297 1.329l.533-.307a1 1 0 0 1 1 1.732l-.53.306a4.5 4.5 0 0 1 0 2.656l.53.306a1 1 0 0 1-1 1.732l-.533-.307a4.5 4.5 0 0 1-2.297 1.329V11a1 1 0 1 1-2 0v-.612a4.5 4.5 0 0 1-2.297-1.329l-.533.307A.997.997 0 0 1 13.304 9a1 1 0 0 1 .366-1.366M16 6c0 1.379 1.122 2.5 2.5 2.5S21 7.379 21 6s-1.122-2.5-2.5-2.5A2.503 2.503 0 0 0 16 6m7.822 7.43a1 1 0 0 0-1.392-.251l-13 9.021a1 1 0 1 0 1.14 1.643l13-9.021a1 1 0 0 0 .252-1.392"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-challenge-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrChallengeAlt;
